export default __webpack_public_path__ + "plugfones-mercenary-lt.52d59026.jpg";